import React from 'react'
// import { Layout } from '@brainstud/react-tbl/features/modals'
import { Page, PageContent, Icon, Heading, Text, Button } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { ModalPopup } from '@brainstud/react-tbl/themes/pgw/v1/components/modals'

const QuizConfirmSubmit = props => (
  <ModalPopup {...props}>
    <Page name="ContentModal" style={{ position: 'relative' }}>
      <PageContent>
        <Heading h2>Je staat op het punt om je toets in te leveren</Heading>
        <Text>Weet je zeker dat je klaar bent? Lever dan je toets in.</Text>
        <br />
        <Button
          onClick={props.data.onClick}
          primary label="Inleveren" icon="arrow-right" iconPosition="right" />
      </PageContent>

      <a onClick={props.app.toggleModal} className="Modal-popup-close">
        <Icon name="close" />
      </a>
    </Page>
  </ModalPopup>
)

export default QuizConfirmSubmit
